module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_8023.b118c320.png";